"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _cccisdFormik = require("cccisd-formik");
var _format = _interopRequireDefault(require("date-fns/format"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var _default = exports["default"] = {
  handle: 'date',
  label: 'Date',
  initialSettings: {
    format: 'MM/DD/YYYY'
  },
  SettingsComponent: function SettingsComponent() {
    return /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
      name: "format",
      component: _cccisdFormik.CccisdInput,
      label: "Format"
    });
  },
  getColumnSettings: function getColumnSettings(settings) {
    return {
      render: function render(_ref) {
        var value = _ref.value,
          row = _ref.row;
        return value && (0, _format["default"])(value, settings.format);
      }
    };
  }
};